import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=f91b3e26"
import script from "./BannerCard.vue?vue&type=script&lang=js"
export * from "./BannerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports